module.exports = __webpack_public_path__ + "img/retail_tipo.5ec93cb4.svg";